import { createFileRoute, Link } from '@tanstack/react-router';

function PostPage() {
  const { postId } = Route.useParams();
  return (
    <div>
      <h1 style={{ marginBottom: '10px', color: '#333', fontSize: '1.5rem' }}>
        Dynamic Route Segment: Post {postId}
      </h1>
      <p style={{ marginBottom: '15px', color: '#666', fontSize: '14px' }}>
        $postId 세그먼트를 사용해 URL에서 동적 파라미터를 받습니다. 현재 값: <strong>{postId}</strong>
      </p>
      <Link to="/posts/$postId/edit" params={{ postId }} style={{ color: '#0066cc' }}>
        Edit 페이지로
      </Link>
    </div>
  );
}

export const Route = createFileRoute('/sample/posts/$postId')({
  component: PostPage,
});

